import { cn } from "@newxsystems/shared";
import { RavioliCardLink } from "../../../../modules/content/components/RavioliCardLink/RavioliCardLink";
import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliRichText } from "../../../../modules/content/components/RavioliRichText/RavioliRichText";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;
const spans = {
  1: "sm:col-span-1",
  2: "sm:col-span-2",
  3: "sm:col-span-2 md:col-span-3",
  4: "sm:col-span-2 md:col-span-3 lg:col-span-4",
} as const;

export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;
  const effectiveColumnCount = Math.min(columnCount || 3, items.length) as 1 | 2 | 3 | 4;

  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-8">
        <RavioliCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid gap-4", columns[effectiveColumnCount])}>
          {items.map((item, index) => (
            <RavioliCardLink
              className={cn(
                "min-h-56 border-primary p-6",
                item.columnSpan && item.columnSpan > 1
                  ? "bg-collection"
                  : index % 2 === 0
                    ? "bg-surface"
                    : "bg-collection",
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <h3 className="max-w-[18ch] font-ravioli-display text-3xl font-semibold leading-[1.05] text-foreground">
                {item.heading}
              </h3>
              {item.description ? (
                <RavioliRichText
                  className="mt-4 text-base text-ink-muted md:text-lg"
                  content={item.description}
                />
              ) : null}
            </RavioliCardLink>
          ))}
        </div>
      </div>
    </RavioliSection>
  );
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
